<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-petrenger">
      <div class="px-3 col-3 p-0">
        <div class="heading-petrenger">{{ $t("result.round") }}</div>
        <div class="text-subhead-petrenger">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-petrenger">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-petrenger">
          {{ data.count === 0
            ? data.bet
            : data.detail.summary[data.count].bet.amount | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-petrenger">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-petrenger">
          {{ winlose | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-petrenger">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-petrenger">
          {{ balance | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-petrenger pt-3">
      <div class="text-games-petrenger">{{ "Pet Hero" }}</div>
      <div class="text-subgame-petrenger">{{ $t("petrenger.title") }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0 align-items-center" style="margin-top: 30px">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="isFreespin || isRespin || isBonus" class="fas fa-caret-left arrow-side-petrenger"
            @click="delCount()"></i>
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex flex-row justify-content-center">
            <img v-if="winSum > 0" class="icon-symbol-petrenger"
              :src="require(`../../assets/resultGame/petrenger/win.png`)" alt="" />
            <img v-else class="icon-symbol-petrenger" :src="require(`../../assets/resultGame/petrenger/lose.png`)"
              alt="" />
          </div>
          <div class="d-flex flex-row slot-container">
            <div class="d-flex flex-column mg-side">
              <div v-for="(reel, index) in this.reels[0]" :key="index">
                <img v-if="index != wildCount[0][1]"
                  :class="`icon-symbol-petrenger symbol_${wildCount[0][0]}_${wildCount[0][1]}`"
                  :src="require(`../../assets/resultGame/petrenger/symbol_${reel}.png`)" alt="" />
                <img v-if="index == wildCount[0][1]"
                  :class="`icon-symbol-petrenger symbol-wild wild_${wildCount[0][0]}_${wildCount[0][1]}`"
                  :src="require(`../../assets/resultGame/petrenger/wild_0.png`)" alt="" />
              </div>
            </div>
            <div class="d-flex flex-column mg-side">
              <div v-for="(reel, index) in this.reels[1]" :key="index">
                <img v-if="index != wildCount[1][1]"
                  :class="`icon-symbol-petrenger symbol_${wildCount[1][0]}_${wildCount[1][1]}`"
                  :src="require(`../../assets/resultGame/petrenger/symbol_${reel}.png`)" alt="" />
                <img v-if="index == wildCount[1][1]"
                  :class="`icon-symbol-petrenger symbol-wild wild_${wildCount[1][0]}_${wildCount[1][1]}`"
                  :src="require(`../../assets/resultGame/petrenger/wild_1.png`)" alt="" />
              </div>
            </div>
            <div class="d-flex flex-column mg-side">
              <div v-for="(reel, index) in this.reels[2]" :key="index">
                <img v-if="index != wildCount[2][1]"
                  :class="`icon-symbol-petrenger symbol_${wildCount[2][0]}_${wildCount[2][1]}`"
                  :src="require(`../../assets/resultGame/petrenger/symbol_${reel}.png`)" alt="" />
                <img v-if="index == wildCount[2][1]"
                  :class="`icon-symbol-petrenger symbol-wild wild_${wildCount[2][0]}_${wildCount[2][1]}`"
                  :src="require(`../../assets/resultGame/petrenger/wild_2.png`)" alt="" />
              </div>
            </div>
            <div class="d-flex flex-column mg-side">
              <div v-for="(reel, index) in this.reels[3]" :key="index">
                <img v-if="index != wildCount[3][1]"
                  :class="`icon-symbol-petrenger symbol_${wildCount[3][0]}_${wildCount[3][1]}`"
                  class="icon-symbol-petrenger" :src="require(`../../assets/resultGame/petrenger/symbol_${reel}.png`)"
                  alt="" />
                <img v-if="index == wildCount[3][1]"
                  :class="`icon-symbol-petrenger symbol-wild wild_${wildCount[3][0]}_${wildCount[3][1]}`"
                  :src="require(`../../assets/resultGame/petrenger/wild_3.png`)" alt="" />
              </div>
            </div>
            <div class="d-flex flex-column mg-side">
              <div v-for="(reel, index) in this.reels[4]" :key="index">
                <img v-if="index != wildCount[4][1]"
                  :class="`icon-symbol-petrenger symbol_${wildCount[4][0]}_${wildCount[4][1]}`"
                  :src="require(`../../assets/resultGame/petrenger/symbol_${reel}.png`)" alt="" />
                <img v-if="index == wildCount[4][1]"
                  :class="`icon-symbol-petrenger symbol-wild wild_${wildCount[4][0]}_${wildCount[4][1]}`"
                  :src="require(`../../assets/resultGame/petrenger/wild_4.png`)" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-petrenger" @click="addCount()"></i>
        </div>
      </div>
      <div class="text-center py-4 text-games-petrenger">
        <h1 v-if="isFreespin">
          {{ $t("result.freespin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}
        </h1>
        <h1 v-else> {{ $t("main-game.spin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
      </div>
      <div v-if="winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3" />
        <div class="text-detail align-items-center d-flex px-3">
          {{ $t("result.detail") }}
        </div>
        <hr class="line col-3" />
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-petrenger"> {{ $t("featurebuy.title") }} </div>
      <div v-if="winnings.length" class="col-12 justify-content-start d-flex flex-row">
        <div class=" bet-box-petrenger p-2 px-3 justify-content-start align-items-center container">
          <h1 class="my-1 green">{{ $t("result.multiplier") }} x {{ this.multiplier }}</h1>
          <div class="bet-wrapper justify-content-between item d-flex col-12 detail-height"
            v-for="(detail, index) in winnings" :key="index">
            <div class="d-flex flex-row">
              <img class="icon-detail-petrenger"
                :src="require(`../../assets/resultGame/petrenger/symbol_${detail.symbol}.png`)" alt="" />
              <div class="d-flex text-win align-items-center justify-content-center">
                <p class="my-1 green">{{ ` ${detail.count} ` + $t("result.kind") }}</p>
              </div>
            </div>
            <div class="d-flex text-win justify-content-center align-items-center px-3">
              <p class="my-1 green"> {{ currency }} {{ detail.amount | currencyFormatter }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-petrenger",
  props: {
    data: Object,
    lang: String,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      reels: [],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      date: '',
      time: '',
      count: this.data.count,
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreespin: false,
      multiplier: 0,
      isEndRound: false,
      pages: 0,
      state: '-',
      nextState: '-',
      multiplierReel: null,
      isBonus: false,
      symbolsBonus: null,
      bonusGame: null,
      bonusReels: [],
      freeSpin: null,
      wildCount: [],
    }
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header-petrenger')[0].offsetHeight
    },
    mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.multiplier = result.multiplier
      this.isFreespin = (result.state === 'FREESPIN' || result.state === 'FREERESPIN')
      this.isRespin = result.state === 'RESPIN'
      this.isBonus = result.state === 'BONUSGAME'
      this.state = result.state;
      this.nextState = result.nextState;
      this.symbolsBonus = result.bonusWin

      this.reels = result.reels;
      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;
      this.multiplierReel = result.multiplierReels;
      this.bonusReels = result.bonusReels;
      this.freeSpin = result.freeSpin;
      this.wildCount = [];
      let currentBet = 0;
      if (this.isFreespin) {
        currentBet = this.data.count != 0 ? result.bet.amount : result.roundAmount;
      } else {
        currentBet = result.bet.amount
      }
      this.winSum = result.win - currentBet;
      for (let i = 0; i < this.reels.length; i++) {
        let wildLength = this.reels[i].filter(i => i === 10).length
        let wildIndex = this.reels[i].indexOf(10)
        let wild = new Array(wildLength, wildIndex)
        this.wildCount.push(wild)
      }

      this.bonusGame = result.bonusGame;
      if (result.isCoin) this.currency = 'AMS';
    },
    convertNumberAbbreviated(val) {
      let suffix = ""
      if (val > 999999) {
        val = val / 1000000
        suffix = "M"
      } else if (val > 9999) {
        val = val / 1000
        suffix = "K"
      }
      return String(this.APPLY_EPSILON(val) + suffix);
    },
    getBaseForEPSILON(num) {
      let base = 100;
      if (num > -10 && num < 10) {
        base = 1000
      } else if (num >= 10 && num < 10000) {
        base = 100
      } else if (num >= 10000 && num < 1000000) {
        base = 10
      } else {
        base = 100
      }
      return base;
    },
    APPLY_EPSILON(num) {
      return (Math.round(((num) + Number.EPSILON) * this.getBaseForEPSILON(num)) / this.getBaseForEPSILON(num))
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  }
};
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  margin: 0;
}

.symbol_1_0,
.symbol_2_0,
.symbol_3_0 {
  transform: translate(0, 100%) !important;
}

.wild_1_0 {
  transform: translate(-10%, -75%) !important;
  height: 100% !important;
}

.wild_2_0 {
  transform: translate(-10%, -50%) !important;
  height: 100% !important;
}

.wild_3_0 {
  transform: translate(-10%, -25%) !important;
  height: 100% !important;
}

.symbol-wild {
  position: absolute;
  width: 25% !important;
  padding-left: 3%;
  padding-right: 3%;
  transform: translate(-25px, 0px);
  z-index: 2 !important;
}

.mg-side {
  margin-left: 5px !important;
  margin-right: 5px !important;
}

.slot-container {
  margin-top: 20px;
  position: relative;
  /* align-items: center; */
  overflow: hidden;
}

.icon-symbol-petrenger {
  width: 100%;
  z-index: 1;
  /* padding: 5%; */
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.text-win {
  height: 144px
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-petrenger {
  width: 140px;
  height: 144px;
  padding: 4px;
}

.icon-bonus-petrenger {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-petrenger {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-petrenger {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 200px;
  max-height: 400px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.bonus-box-petrenger {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-petrenger .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-petrenger .bet-wrapper-petrenger:not(:first-child) .item {
  margin-top: 10px;
  /* width: 800px; */
}

.bet-wrapper-petrenger,
.result-wrapper {
  font-size: 35px;
  /* width: 800px; */
}

.header-petrenger {
  background: #c05434;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-petrenger>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-petrenger {
  color: #000000;
  text-align: center;
}

.content-result-petrenger {
  background: #7A3621;
  height: 180vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-petrenger {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-petrenger {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-petrenger {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-petrenger {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.bet-box-petrenger {
  min-width: 600px;
  max-width: auto;
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-108px, 0px);
}

.icon-symbol.-level1 {
  width: 109px;
  height: 89px;
}

.icon-symbol.-level2 {
  width: 109px;
  height: 176px;
}

.icon-symbol.-level3 {
  width: 109px;
  height: 266px;
}

.icon-symbol.-level4 {
  width: 112px;
  height: 352px;
}

.multiplier-container {
  width: 100%;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 689px;
  text-align: center;
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 35px;
}

.win-box {
  width: 689px;
}


@media screen and (max-width: 1030px) {
  .symbol-wild {
    position: absolute;
    width: 26% !important;
    padding-left: 3%;
    padding-right: 4%;
    transform: translate(-25px, 0px);
    z-index: 2 !important;
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-petrenger {
    min-width: 580px;
    max-width: auto;
    height: 100%;
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-126px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 104px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 209px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 314px;
  }

  .icon-symbol.-level4 {
    width: 127px;
    height: 419px;
  }

  .icon-detail-petrenger {
    width: 129.6px;
    height: 150px;
  }

  .text-win {
    height: 150px;
  }

  .my-1 {
    font-size: 40px !important;
  }

  .bet-box-petrenger {
    /* background: #0c161f; */
    border-radius: 10px;
    min-height: 200px;
    max-height: 530px;
    overflow-y: scroll;
    min-width: 100px;
    max-width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 800px;
  }
}

@media screen and (max-width: 1080px) {
  .symbol-wild {
    position: absolute;
    width: 26% !important;
    padding-left: 3%;
    padding-right: 4%;
    transform: translate(-25px, 0px);
    z-index: 2 !important;
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
    margin-left: -34px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-petrenger {
    min-width: 580px;
    max-width: auto;
    height: 100%;
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-126px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 105px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 210px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 315px;
  }

  .icon-symbol.-level4 {
    width: 126px;
    height: 419px;
  }

  .icon-detail-petrenger {
    width: 129.6px;
    height: 150px;
  }

  .text-win {
    height: 150px;
  }

  .my-1 {
    font-size: 40px !important;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .bet-box-petrenger {
    /* background: #0c161f; */
    border-radius: 10px;
    min-height: 200px;
    max-height: 530px;
    overflow-y: scroll;
    min-width: 100px;
    max-width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 800px;
  }
}

@media screen and (max-width: 770px) {
  .symbol-wild {
    position: absolute;
    width: 25% !important;
    padding-left: 3%;
    padding-right: 4%;
    transform: translate(-25px, 0px);
    z-index: 2 !important;
  }

  .heading-petrenger {
    font-size: 18px;
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-petrenger {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-petrenger {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 67%;
    transform: translate(104px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }

  .multiplier-container {
    width: 80%;
  }

  .text-multiplier {
    width: 505px;
    text-align: center;
  }

  .green {
    font-size: 40px;
  }
}

@media screen and (max-width: 800px) {
  .symbol-wild {
    position: absolute;
    width: 25% !important;
    padding-left: 2%;
    padding-right: 4%;
    transform: translate(-25px, 0px);
    z-index: 2 !important;
  }

  .top-reel {
    width: 67%;
    transform: translate(111px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-111px, 0px);
  }

  .icon-symbol.-level1 {
    width: 110px;
    height: 92px;
  }

  .icon-symbol.-level2 {
    width: 111px;
    height: 183px;
  }

  .icon-symbol.-level3 {
    width: 111px;
    height: 275px;
  }

  .icon-symbol.-level4 {
    width: 111px;
    height: 367px;
  }

  .icon-detail-petrenger {
    width: 129.6px;
    height: 144px;
  }

  .text-win {
    height: 140px;
  }

  .my-1 {
    font-size: 40px !important;
  }

  .bet-box-petrenger {
    /* background: #0c161f; */
    border-radius: 10px;
    min-height: 200px;
    max-height: 350px;
    overflow-y: scroll;
    min-width: 100px;
    max-width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 800px;
  }
}

@media screen and (max-width: 780px) {
  .symbol-wild {
    position: absolute;
    width: 25% !important;
    padding-left: 3%;
    padding-right: 3%;
    transform: translate(-25px, 0px);
    z-index: 2 !important;
  }

  .top-reel {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 67%;
    transform: translate(105px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }

  .icon-detail-petrenger {
    width: 108px;
    height: 120px;
  }

  .text-win {
    height: 100px;
  }

  .my-1 {
    font-size: 30px !important;
  }

  .bet-box-petrenger {
    /* background: #0c161f; */
    border-radius: 10px;
    min-height: 200px;
    max-height: 420px;
    overflow-y: scroll;
    min-width: 100px;
    max-width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 800px;
  }
}

@media screen and (max-width: 600px) {
  .symbol-wild {
    position: absolute;
    width: 25% !important;
    padding-left: 3%;
    padding-right: 4%;
    transform: translate(-15px, 0px);
    z-index: 2 !important;
  }

  .top-reel {
    width: 67%;
    transform: translate(82px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-83px, 0px);
  }

  .icon-symbol.-level1 {
    width: 83px;
    height: 70px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 138px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 207px;
  }

  .icon-symbol.-level4 {
    width: 83px;
    height: 275px;
  }

  .icon-detail-petrenger {
    width: 108px;
    height: 120px;
  }

  .text-win {
    height: 100px;
  }

  .my-1 {
    font-size: 30px !important;
  }

  .bet-box-petrenger {
    /* background: #0c161f; */
    border-radius: 10px;
    min-height: 200px;
    max-height: 400px;
    overflow-y: scroll;
    min-width: 100px;
    max-width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 800px;
  }

}

@media screen and (max-width: 360px) {
  .symbol-wild {
    position: absolute;
    width: 23% !important;
    padding-left: 3%;
    padding-right: 4%;
    transform: translate(-6px, 0px);
    z-index: 2 !important;
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-petrenger>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-petrenger {
    font-size: 12px;
  }

  .text-subhead-petrenger {
    font-size: 14px;
  }

  .bet-box-petrenger {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-petrenger {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-petrenger,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-petrenger {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-petrenger {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(62px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-63px, 0px);
  }

  .icon-symbol.-level1 {
    width: 63px;
    height: 52px;
  }

  .icon-symbol.-level2 {
    width: 63px;
    height: 104px;
  }

  .icon-symbol.-level3 {
    width: 63px;
    height: 155px;
  }

  .icon-symbol.-level4 {
    width: 63px;
    height: 207px;
  }

  .green {
    font-size: 18px;
  }

  .text-win {
    height: 57px;
  }
}

@media screen and (max-width: 480px) {
  .symbol-wild {
    position: absolute;
    width: 23% !important;
    padding-left: 3%;
    padding-right: 4%;
    transform: translate(-6px, 0px);
    z-index: 2 !important;
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-petrenger>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-petrenger {
    font-size: 12px;
  }

  .text-subhead-petrenger {
    font-size: 14px;
  }

  .bet-box-petrenger {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-petrenger {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-petrenger,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-petrenger {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-petrenger {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(62px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-63px, 0px);
  }

  .icon-symbol.-level1 {
    width: 63px;
    height: 52px;
  }

  .icon-symbol.-level2 {
    width: 63px;
    height: 104px;
  }

  .icon-symbol.-level3 {
    width: 63px;
    height: 155px;
  }

  .icon-symbol.-level4 {
    width: 63px;
    height: 207px;
  }

  .green {
    font-size: 18px;
  }

  .text-win {
    height: 57px;
  }
}

@media screen and (max-width: 550px) {
  .symbol-wild {
    position: absolute;
    width: 25% !important;
    padding-left: 3%;
    padding-right: 4%;
    transform: translate(-15px, 0px);
    z-index: 2 !important;
  }

  .top-reel {
    width: 67%;
    transform: translate(82px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-83px, 0px);
  }

  .icon-symbol.-level1 {
    width: 83px;
    height: 70px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 138px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 207px;
  }

  .icon-symbol.-level4 {
    width: 83px;
    height: 275px;
  }

  .icon-detail-petrenger {
    width: 108px;
    height: 120px;
  }

  .text-win {
    height: 100px;
  }

  .my-1 {
    font-size: 30px !important;
  }

  .bet-box-petrenger {
    /* background: #0c161f; */
    border-radius: 10px;
    min-height: 200px;
    max-height: 400px;
    overflow-y: scroll;
    min-width: 100px;
    max-width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 800px;
  }
}
</style>